import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';

@Component({
  selector: 'tpc-fleet-default',
  templateUrl: './fleet-default.component.html',
  styleUrls: ['./fleet-default.component.css']
})
export class FleetDefaultComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private _form: FormGroup;

    constructor(protected footerService: FooterNavbarService,
                protected router: Router,
                protected fb: FormBuilder
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });

        this.createForm();
    }

    checkError(param): boolean {
        return this.form.get(param).status === 'INVALID' && this.isFormSubmitted;
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm(): void {
        this._form = this.fb.group({
            vehicleType: ['car', Validators.required ]
        });
    }

    next() {
        this.isFormSubmitted = true;
        this.router.navigate(['/business/fleet/' + this.form.get('vehicleType').value]);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-default/fleet-default.component.ts